<div class="box {{ article.class }} type-{{ type }}">
  <div class="box__shadow"></div>
  <div class="box__content">

    <div class="tags" *ngIf="article?.category">
      <a (click)="selectTag(article?.category.name)">
        <span [style.background]="'#' + article?.category.color"></span>{{ article?.category.name }}
      </a>
    </div>

    <ng-template #articleVontent>
      <div class="image"
           [ngClass]="{'video': (article['files'] && isVideo(article['files'][0]) && !article?.pagelink && !article?.link), 'download': (article['only_for_download'] && !isVideo(article['files'][0]) && !article?.pagelink && !article?.link) }"
      >

        <picture>
          <source [attr.defaultImage]="'/assets/images/load.gif'" [attr.lazyLoad]="article?.image_list_lg" media="(min-width: 1200px)">
          <source [attr.defaultImage]="'/assets/images/load.gif'" [attr.lazyLoad]="article?.image_list_md" media="(min-width: 992px)">
          <source [attr.defaultImage]="'/assets/images/load.gif'" [attr.lazyLoad]="article?.image_list_sm" media="(min-width: 768px)">
          <img [defaultImage]="'/assets/images/load.gif'" [lazyLoad]="article.image_list_xs" [alt]="article.image_alt ? article.image_alt : article.title" />
        </picture>

      </div>

      <p *ngIf="type === 'knowledge'" class="text-header text-header--article" [innerHTML]="article?.title"></p>
      <div class="texts" *ngIf="type != 'knowledge'" >
        <p class="text-header text-header--article" [innerHTML]="article?.title"></p>
        <div class="text2" *ngIf="showEntry" [innerHTML]="article?.short_content"></div>
      </div>
    </ng-template>


    <ng-container *ngIf="article['only_for_download']">

      <div class="box__link" *ngIf="isVideo(article['files'][0])" (click)="itemClick(); openVideo(article['files'][0])">
        <ng-container *ngTemplateOutlet="articleVontent"></ng-container>
      </div>

      <div class="box__link" *ngIf="!isVideo(article['files'][0])" (click)="itemClick(); getFile(article['files'][0]);">
        <ng-container *ngTemplateOutlet="articleVontent"></ng-container>
      </div>

      <div class="buttons">
        <button
        class="iconBtn"
        *ngIf="
          isVideo(article['files'][0])
        "
        (click)="getFile(article['files'][0])">
        <span>Pobierz</span>
        <span class="icon">
          <img src="/assets/images/icons/download.svg" alt="pobierz">
        </span>
        </button>
      </div>



    </ng-container>
    <ng-container *ngIf="!article['only_for_download']">

      <div class="box__link" *ngIf="!article?.pagelink && !article?.link" (click)="itemClick()">
        <ng-container *ngTemplateOutlet="articleVontent"></ng-container>
      </div>

       <a class="box__link" *ngIf="article?.pagelink && !article?.link" [routerLink]="[link, article?.slug]">
         <ng-container *ngTemplateOutlet="articleVontent"></ng-container>
       </a>

       <a class="box__link" *ngIf="article?.link && !article?.pagelink" href="{{ article?.link }}" target="_blank" rel="nofollow">
         <ng-container *ngTemplateOutlet="articleVontent"></ng-container>
       </a>

       <div class="buttons">
        <button
        class="iconBtn"
        *ngIf="article['files'] &&
          isVideo(article['files'][0])
        "
        (click)="openVideo(article['files'][0])"><span>Zobacz film</span>
        <span class="icon">
          <img src="/assets/play.webp" alt="zobacz film">
        </span>
        </button>
        <button
        class="iconBtn"
        *ngIf="
          article['files'] &&
          article['files'][0]
        "
        (click)="getFile(article['files'][0])"><span>Pobierz</span>
        <span class="icon">
          <img src="/assets/images/icons/download.svg" alt="pobierz">
        </span>
        </button>
       </div>


    </ng-container>





  </div>

</div>


